import jwtDecode from 'jwt-decode';
import { secondsInMs } from "../lib/util/time.js";
export const LS_KEY_USER_ID = 'xjnSUQnpZU';
export const LS_KEY_ACCESS_TOKEN = 'QhiUizqDML';
export function storeIdAndTokenInLS({ accessToken, userId, }) {
    if (!window.localStorage) {
        return;
    }
    window.localStorage.setItem(LS_KEY_USER_ID, userId);
    window.localStorage.setItem(LS_KEY_ACCESS_TOKEN, accessToken);
}
export function clearIdAndTokenInLS() {
    window.localStorage.removeItem(LS_KEY_USER_ID);
    window.localStorage.removeItem(LS_KEY_ACCESS_TOKEN);
}
export function maybeGetBaseUser() {
    if (!window.localStorage) {
        return;
    }
    const accessToken = maybeGetAccessToken();
    const userId = window.localStorage.getItem(LS_KEY_USER_ID);
    if (!accessToken && userId) {
        window.localStorage.removeItem(LS_KEY_USER_ID);
    }
    if (!accessToken || !userId) {
        return;
    }
    return {
        userId,
    };
}
export function maybeGetAccessToken() {
    const accessToken = window.localStorage.getItem(LS_KEY_ACCESS_TOKEN);
    if (!accessToken || isTokenExpired(accessToken)) {
        window.localStorage.removeItem(LS_KEY_ACCESS_TOKEN);
        return;
    }
    return accessToken;
}
function isTokenExpired(accessToken) {
    if (!window.localStorage) {
        return true;
    }
    if (!accessToken) {
        return true;
    }
    const decoded = jwtDecode(accessToken);
    const expirationTimestampInSeconds = decoded.exp;
    if (expirationTimestampInSeconds === undefined) {
        return false;
    }
    const expirationTimestampMs = secondsInMs(expirationTimestampInSeconds);
    return expirationTimestampMs < Date.now();
}
//# sourceMappingURL=token.js.map